import type { ObjectId } from "@bbj-types/utils";
import type { IDateRange } from "@styleguide";
import { useCallback } from "react";
import { axios } from "../axios";

export interface ISocialOfferSpotlightBody {
  dates: IDateRange;
  teams?: string[];
}

export const useAddSocialOfferSpotlight = () => {
  const [state, execute, cancel] = axios<ObjectId, ISocialOfferSpotlightBody, unknown>(
    {
      method: "patch",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, data: ISocialOfferSpotlightBody) => {
      return execute({
        url: `/offers/social/spotlight/add/${id}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
